import { IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import {
  cellFormat,
  formatDateToLocal,
} from '../../../../../../lib/designSystem/Table/cellFormat';
import FactoringSteps from './components/factoringSteps';
import CreditLineSteps from './components/creditLineSteps';
import { getShortString } from '../../../../../../lib/functions/utils';
import { Info } from '@mui/icons-material';
import NetworkBusinessDetails from '../../../../../Network/components/Businesses/components/Details';
import EditIcon from '@mui/icons-material/Edit';
import EditExecutive from './components/editExecutive';

const InforPreview = (props: any) => {
  const {
    selectedRequest,
    status,
    type,
    requestType,
    setUp,
    executivesPortfolio,
    executivesAll,
  } = props;
  const [openBusinessDetails, setOpenBusinessDetails] = useState(false);
  const [businessForDetails, setBusinessForDetails] = useState<any>(null);
  const [openEditExecutive, setOpenEditExecutive] = useState(false);
  const [executive, setExecutive] = useState(selectedRequest.executiveId);

  const rowStyle = {
    padding: '8px 0px 4px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  };

  const handleShowBusinessDetails = () => {
    setBusinessForDetails({
      id: selectedRequest.businessIdentifier,
      name: selectedRequest.businessName,
    });
    setOpenBusinessDetails(true);
  };

  const handleEditExecutive = () => {
    setOpenEditExecutive(true);
  };

  return (
    <div style={{ paddingTop: 8 }}>
      {type === 'Recieved' ? (
        <>
          <div style={rowStyle}>
            <Typography fontWeight="bold">Cliente</Typography>
            <Typography>
              {getShortString(selectedRequest.businessName, 50)}
            </Typography>
          </div>
          <div style={rowStyle}>
            <Typography fontWeight="bold">Rut</Typography>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <IconButton onClick={handleShowBusinessDetails}>
                <Info fontSize="small" />
              </IconButton>
              <Typography>{selectedRequest.businessIdentifier}</Typography>
            </div>
          </div>
        </>
      ) : (
        selectedRequest.recipient && (
          <div style={rowStyle}>
            <Typography fontWeight="bold">Financiera</Typography>
            <Typography>{selectedRequest.recipientName}</Typography>
          </div>
        )
      )}
      {type === 'Recieved' ? (
        <>
          <div style={rowStyle}>
            <Typography fontWeight="bold">Contacto</Typography>
            <Typography>{selectedRequest.userOwnerName}</Typography>
          </div>
          <div style={rowStyle}>
            <Typography fontWeight="bold">Ejecutivo</Typography>
            <Typography textAlign="right">
              <IconButton onClick={handleEditExecutive}>
                <EditIcon />
              </IconButton>
              {selectedRequest.executiveName
                ? `${selectedRequest.executiveName}`
                : 'Sin asignar'}
            </Typography>
          </div>
        </>
      ) : (
        <div style={rowStyle}>
          <Typography fontWeight="bold">Ejecutivo</Typography>
          <Typography textAlign="right">
            {selectedRequest.executiveName
              ? `${selectedRequest.executiveName}`
              : 'Sin asignar'}
          </Typography>
        </div>
      )}
      <div style={rowStyle}>
        <Typography fontWeight="bold">Email</Typography>
        {type === 'Recieved' ? (
          <Typography>({selectedRequest.userOwnerEmail})</Typography>
        ) : (
          <Typography textAlign="right">
            {selectedRequest.executiveName
              ? `${selectedRequest.executiveEmail}`
              : 'Sin asignar'}
          </Typography>
        )}
      </div>
      <div style={rowStyle}>
        <Typography fontWeight="bold">Fecha operación</Typography>
        <Typography>
          {selectedRequest.requestDate
            ? formatDateToLocal(selectedRequest.requestDate)
            : 'Sin fecha'}
        </Typography>
      </div>

      <div style={rowStyle}>
        <Typography fontWeight="bold">Estado</Typography>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {selectedRequest.exception &&
            cellFormat(selectedRequest.exception, 'boolean-exception-null')}
          <Typography>{cellFormat(status, 'status')}</Typography>
        </div>
      </div>

      <div style={{ padding: '4px 0px' }}>
        <Typography fontWeight="bold">Pasos a seguir</Typography>
        {requestType === 'factoring' && (
          <FactoringSteps
            selectedRequest={selectedRequest}
            status={status}
            type={type}
          />
        )}
        {requestType === 'creditLine' && (
          <CreditLineSteps
            selectedRequest={selectedRequest}
            status={status}
            type={type}
          />
        )}
        {businessForDetails && (
          <NetworkBusinessDetails
            open={openBusinessDetails}
            setOpen={setOpenBusinessDetails}
            business={businessForDetails}
          />
        )}
        {openEditExecutive && (
          <EditExecutive
            openEditExecutive={openEditExecutive}
            setOpenEditExecutive={setOpenEditExecutive}
            executivesPortfolio={executivesPortfolio}
            executivesAll={executivesAll}
            executive={executive}
            setExecutive={setExecutive}
            setUp={setUp}
            selectedRequest={selectedRequest}
          />
        )}
      </div>
    </div>
  );
};

export default InforPreview;
